import { render, staticRenderFns } from "./SalesFiltersTarjeta.vue?vue&type=template&id=8f7fddf0&"
import script from "./SalesFiltersTarjeta.vue?vue&type=script&lang=js&"
export * from "./SalesFiltersTarjeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports